export enum SizeTable {
  SMALL = 400,
  MEDIUM = 600,
  LARGE = 800,
  XLARGE = 968,
}

export type TSize = keyof typeof SizeTable;

export interface IModalProps {
  isOpen: boolean;
  title?: string;
  headerActions?: React.ReactNode;
  footerActions?: React.ReactNode;
  hasCloseButton?: boolean;
  width?: number | string;
  size?: TSize;
  onClose: (event?: React.MouseEvent<HTMLElement>) => void;
  onCloseComplete?: () => void;
  shouldCloseOnOverlayClick?: boolean;
  shouldCloseOnEscapePress?: boolean;
  customFooter?: React.ReactNode;
  className?: string;
  titleIcon?: React.ReactElement;
  hasPadding?: boolean;
}
